import React from "react";
import Start from "./Start";

function App() {
  return (
    <>
      <Start />
    </>
  );
}

export default App;
